import {
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";

export const Interface1HtmlCss4 = () => {
  return (
    <>
      <Grid container spacing={5} alignItems="center">
        <VerticalLinearStepper
          steps={[
            {
              label: "Introductie tot Bootstrap 🧑‍🏫",
              description: `Wat is Bootstrap?`,
              content: (
                <>
                  <Grid container size={12} margin="auto" alignItems={"center"}>
                    <Grid size={6} textAlign="center">
                      <img
                        src="/presentation-data/INTERFACE1/bootstrap-logo-shadow.png"
                        style={{ width: "300px" }}
                        alt="Bootstrap logo"
                      />
                    </Grid>
                    <Grid size={6}>
                      <List sx={{ fontSize: "1.5rem" }}>
                        <ListItem>🆓 Open-source framework</ListItem>
                        <ListItem>🐦 Ontwikkeld door Twitter (X)</ListItem>
                        <Divider sx={{ my: 2 }} />
                        <ListItem>✅ Snel en efficiënt layouts bouwen</ListItem>
                        <ListItem>
                          📱 Mobile-first design out of the box
                        </ListItem>
                        <ListItem>
                          🧱 Verzameling kant-en-klare componenten
                        </ListItem>
                        <ListItem>🎨 Consistente look & feel</ListItem>
                        <ListItem>
                          🤝 Uitgebreide community & documentatie
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>

                  <iframe
                    src="https://getbootstrap.com"
                    width="100%"
                    style={{
                      height: "70vh",
                      border: "1px solid #ccc",
                      marginTop: "100px",
                    }}
                    title="Bootstrap grid example"
                  ></iframe>
                </>
              ),
            },
            {
              label: "Installatie van Bootstrap ⚙️",
              description: `Installatie van Bootstrap kan op verschillende manieren:`,
              content: (
                <>
                  <Stack direction="row" gap={4} justifyContent="center">
                    <Card sx={{ width: 350, textAlign: "center" }}>
                      <CardMedia
                        image="/presentation-data/INTERFACE1/cloud.jpg"
                        sx={{
                          height: 100,
                          backgroundSize: "contain",
                        }}
                      />
                      <CardContent>
                        <Typography variant="h2">CDN</Typography>
                      </CardContent>
                    </Card>
                    <Card sx={{ width: 350, textAlign: "center" }}>
                      <CardMedia
                        image="/presentation-data/INTERFACE1/download.png"
                        sx={{
                          height: 100,
                          backgroundSize: "contain",
                        }}
                      />
                      <CardContent>
                        <Typography variant="h2">Download</Typography>
                      </CardContent>
                    </Card>
                    <Card sx={{ width: 350, textAlign: "center" }}>
                      <CardMedia
                        image="/presentation-data/INTERFACE1/npm.png"
                        sx={{
                          height: 100,
                          backgroundSize: "contain",
                        }}
                      />
                      <CardContent>
                        <Typography variant="h2">NPM</Typography>
                      </CardContent>
                    </Card>
                  </Stack>
                </>
              ),
            },
            {
              label: "Bootstrap basis 🌱",
              description: `Simpele layouts maken met het 12-kolommen systeem van Bootstrap`,
              content: (
                <>
                  <Stack
                    direction="row"
                    gap={4}
                    justifyContent="center"
                    alignItems="center"
                    flexWrap={"wrap"}
                  >
                    <Card sx={{ textAlign: "center" }}>
                      <CardContent>
                        <Typography variant="h2">container</Typography>
                      </CardContent>
                    </Card>

                    <Card sx={{ textAlign: "center" }}>
                      <CardContent>
                        <Typography variant="h2">row</Typography>
                      </CardContent>
                    </Card>

                    <Card sx={{ width: "50%", textAlign: "center" }}>
                      <CardContent>
                        <Typography variant="h2">
                          col-(breakpt)-(number)
                        </Typography>
                      </CardContent>
                    </Card>

                    <Card sx={{ width: "600px", textAlign: "center" }}>
                      <CardContent>
                        <Grid container mt={2} justifyContent="center">
                          <Grid size={4}>
                            <Typography variant="h5">breakpoint</Typography>
                            <List>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="XS"
                                  variant="filled"
                                  color="primary"
                                />
                                &lt;576px
                              </ListItem>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="SM"
                                  variant="filled"
                                  color="primary"
                                />
                                ≥576px
                              </ListItem>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="MD"
                                  variant="filled"
                                  color="primary"
                                />
                                ≥768px
                              </ListItem>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="LG"
                                  variant="filled"
                                  color="primary"
                                />
                                ≥992px
                              </ListItem>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="XL"
                                  variant="filled"
                                  color="primary"
                                />
                                ≥1200px
                              </ListItem>
                              <ListItem>
                                <Chip
                                  sx={{ mr: 1 }}
                                  label="XXL"
                                  variant="filled"
                                  color="primary"
                                />
                                ≥1400px
                              </ListItem>
                            </List>
                          </Grid>
                          <Grid size={4} textAlign="center">
                            <Typography variant="h5">number</Typography>
                            <List sx={{ justifyContent: "center" }}>
                              {Array.from({ length: 6 }, (_, i) => (
                                <ListItem key={i}>
                                  <Chip
                                    label={
                                      i === 4 ? "..." : i === 5 ? "12" : i + 1
                                    }
                                    variant="filled"
                                    color="primary"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    <iframe
                      src="https://getbootstrap.com/docs/5.3/examples/grid/"
                      width="100%"
                      style={{ height: "70vh", border: "1px solid #ccc" }}
                      title="Bootstrap grid example"
                    ></iframe>
                  </Stack>
                </>
              ),
            },
            {
              label: "Bootstrap componenten 🧱",
              description: ``,
              content: (
                <>
                  <iframe
                    title="Bootstrap componenten"
                    src="https://getbootstrap.com/docs/5.3/components/"
                    width="100%"
                    style={{ height: "70vh", border: "1px solid #ccc" }}
                  ></iframe>
                </>
              ),
            },
            {
              label: "Aan de slag! 🚀",
              description: ``,
              content: (
                <>
                  <img
                    src="/presentation-data/INTERFACE1/assignment.png"
                    width="70%"
                    style={{
                      margin: "auto",
                      display: "block",
                      boxShadow: "0 0 10px #CCC",
                      borderRadius: "10px",
                    }}
                    alt="Opdracht 1"
                  />
                </>
              ),
            },
          ]}
        />
      </Grid>
    </>
  );
};
